export default __webpack_public_path__ + "static/media/img-0388-switzerland-premium-face.01a3116d.png";